import { render } from "./register.vue?vue&type=template&id=ee9f40e4&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=ee9f40e4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9f40e4"]])

export default __exports__